<template>
  <div class="min-h-screen mt-aecc">
    <!-- TOP STICKY MENU -->
    <div
      class="fixed w-full bg-gray-50 shadow transition-all duration-300 z-30"
      :class="{ '-top-full md:top-aecc': showMenu, '-top-full': !showMenu }"
    >
      <div class="container lg:max-w-screen-lg mx-auto px-4 py-2">
        <scrollactive
          class="grid grid-cols-2 sm:grid-cols-6 gap-2"
          active-class="scroll-active"
          :offset="scrollOffset"
          @itemchanged="onItemChanged"
        >
          <!-- class="scrollactive-item p-3 rounded-lg transition-shadow h-12 md:h-auto overflow-hidden text-white ring-2 ring-white  ring-offset-white" -->
          <!-- class="scrollactive-item bg-white p-3 shadow-md rounded-lg hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-offset-gray-100 focus:ring-primary transition-shadow h-12 md:h-auto overflow-hidden" -->
          <a
            v-for="section in sections"
            :key="section.id"
            :href="`#${section.id}`"
            class="scrollactive-item relative bg-white p-3 shadow-md rounded-lg hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-offset-gray-100 focus:ring-primary transition-shadow h-12 md:h-auto overflow-hidden group"
          >
            <CustomIcon
              :icon="section.id"
              class="w-8 absolute right-2 top-4 text-gray-200 group-hover:text-gray-300 transition duration-500 z-10 "
            />
            <h3
              class="font-medium text-xs md:text-sm leading-snug relative z-20"
            >
              {{ section.title }}
            </h3>
          </a>
        </scrollactive>
      </div>
    </div>

    <div class="">
      <div class="">
        <!-- <div class="bg-primary pt-12 pb-4 sm:pb-12 mb-12">
          <div class="container lg:max-w-screen-lg mx-auto px-4">
            <div class="text-white">
              <h1
                class="text-5xl md:text-6xl lg:text-8xl font-bison text-center mb-12"
              >
                {{ $t("title") }}
              </h1>

              <p
                v-for="(section, i) in $t('mainText')"
                :key="i"
                class="my-6 text-xl"
              >
                {{ section }}
              </p>
            </div>
          </div>
        </div> -->

        <div class="container lg:max-w-screen-lg mx-auto px-4 mb-16 mt-10">
          <p class="mb-6 text-lg text-gray-500">{{ $t("cardsText") }}</p>
          <!-- TOP CARDS -->
          <scrollactive
            class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 "
            :offset="scrollOffset"
            active-class="text-primary"
            @itemchanged="onItemChanged"
          >
            <!-- class="scrollactive-item bg-white p-5 shadow-md rounded-lg hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-primary transition-shadow" -->
            <!-- class="scrollactive-item p-5 rounded-lg bg-darkgray border-2 border-darkgray text-white focus:outline-none focus:ring-2 focus:ring-offset-white focus:ring-offset-2 focus:ring-white hover:ring-2 hover:ring-offset-white hover:ring-offset-2 hover:ring-white transition-shadow" -->
            <a
              v-for="section in sections"
              :key="section.id"
              :href="`#${section.id}`"
              class="scrollactive-item relative bg-white p-5 shadow-md rounded-lg hover:shadow-xl focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-primary hover:ring-2 hover:ring-offset-2 hover:ring-offset-gray-100 hover:ring-primary transition-shadow group"
            >
              <CustomIcon
                :icon="section.id"
                class="w-16 absolute right-4 top-4 text-gray-400 group-hover:text-primary transition duration-500 z-10 transform group-hover:scale-105"
              />
              <div class="z-20 relative">
                <h3 class="font-bold text-lg leading-snug pr-16 h-12">
                  {{ section.title }}
                </h3>
                <p class="text-gray-500 mt-4">
                  {{ section.desc }}
                </p>
              </div>
            </a>
          </scrollactive>

          <div class="mt-4 flex justify-end">
            <button
              class="btn"
              aria-label="Metodología"
              @click="showModal = true"
            >
              Metodología
            </button>
          </div>
        </div>
      </div>

      <div v-for="section in sections" :key="section.id" class="mb-16 sm:mb-32">
        <div class="bg-lightgray  py-8 mb-16">
          <div class="container lg:max-w-screen-lg mx-auto px-4 ">
            <h2 :id="section.id" class="text-4xl font-bison mb-4 mt-0">
              {{ section.title }}
            </h2>
            <div class="mt-6 text-xl">{{ section.intro }}</div>
          </div>
        </div>

        <div
          v-for="(component, i) in section.components"
          :key="i"
          class="container lg:max-w-screen-lg mx-auto px-4 mb-16"
        >
          <p
            class="text-gray-900 mb-12 text-lg"
            v-html="$t(`questions.${component.question}.context`)"
          ></p>
          <div class="md:max-w-screen-md sm:mx-auto -mx-4">
            <div class="border-b sm:border-none sm:shadow-md sm:rounded-lg">
              <h3
                class="font-medium texty-lg bg-gray-100 p-4 sm:p-6 sm:rounded-t-lg"
                v-html="$t(`questions.${component.question}.question`)"
              ></h3>

              <div class="p-4 sm:p-6 overflow-hidden">
                <component
                  :is="component.component"
                  :question="component.question"
                  :order="component.order"
                  :default-order="component.defaultOrder"
                  :colors="component.colors"
                  :order-dir="component.orderDir"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <TwModal :is-open="showModal" @close="showModal = false">
      <span slot="header">Metodología y ficha técnica</span>
      <div slot="body">
        <ModalContent /></div
    ></TwModal>
    <ScrollTopButton></ScrollTopButton>
  </div>
</template>

<script>
import BarChartSimple from "@/views/BarChartSimple";
import BarChartFollowUp from "@/views/BarChartFollowUp";
import StackedSimple from "@/views/StackedSimple";
import StackedSimpleFollowUp from "@/views/StackedSimpleFollowUp";
import StackedSegments from "@/views/StackedSegments";
import StackedSegmentsFollowUp from "@/views/StackedSegmentsFollowUp";
import DonutFollowUp from "@/views/DonutFollowUp";
import DonutBarChart from "@/views/DonutBarChart";
import HeatMapSimple from "@/views/HeatMapSimple";
import Likert from "@/views/Likert";
import ColumnChartSimple from "@/views/ColumnChartSimple";
import ScrollTopButton from "@/components/ScrollTopButton";
import CustomIcon from "@/components/CustomIcon";
import TwModal from "@/components/TwModal";
import ModalContent from "@/components/ModalContent";

import IDS from "@/utils/ids";
import colors from "@/utils/colors";

export default {
  name: "App",
  components: {
    BarChartSimple,
    BarChartFollowUp,
    StackedSimple,
    StackedSegments,
    StackedSegmentsFollowUp,
    StackedSimpleFollowUp,
    DonutFollowUp,
    DonutBarChart,
    ScrollTopButton,
    HeatMapSimple,
    Likert,
    CustomIcon,
    TwModal,
    ModalContent,
    ColumnChartSimple,
  },
  data() {
    return {
      sections: [
        {
          id: "percepcion",
          title: this.$t("sections.percepcion.title"),
          desc: this.$t("sections.percepcion.desc"),
          intro: this.$t("sections.percepcion.intro"),
          components: [
            {
              component: "StackedSimple",
              question: 4,
              defaultOrder: IDS.MUY_GRAVE,
              order: {
                [IDS.MUY_GRAVE]: 3,
                [IDS.GRAVE]: 2,
                [IDS.NSNC]: 1,
                [IDS.POCO_GRAVE]: 0,
              },
              colors: {
                [IDS.MUY_GRAVE]: "bg-c1",
                [IDS.GRAVE]: "bg-c2",
                [IDS.NSNC]: "bg-nsnc",
                [IDS.POCO_GRAVE]: "bg-c4",
              },
            },
            { component: "BarChartFollowUp", question: 5 },
            { component: "BarChartSimple", question: 3 },
          ],
        },
        {
          id: "vivencias",
          title: this.$t("sections.vivencias.title"),
          desc: this.$t("sections.vivencias.desc"),
          intro: this.$t("sections.vivencias.intro"),
          components: [
            { component: "DonutFollowUp", question: 10 },
            { component: "DonutBarChart", question: 11 },
          ],
        },
        {
          id: "imagen",
          title: this.$t("sections.imagen.title"),
          desc: this.$t("sections.imagen.desc"),
          intro: this.$t("sections.imagen.intro"),
          components: [
            {
              component: "Likert",
              question: 14,
              defaultOrder: "positive",
              order: {
                [IDS.NSNC2]: 5,
                [IDS.TOTALMENTE_DESACUERDO]: 4,
                [IDS.EN_DESACUERDO]: 3,
                [IDS.DE_ACUERDO]: 2,
                [IDS.TOTALMENTE_ACUERDO]: 1,
                [IDS.NSNC]: 0,
              },
              colors: {
                [IDS.TOTALMENTE_DESACUERDO]: "bg-c1",
                [IDS.EN_DESACUERDO]: "bg-c2",
                [IDS.NSNC]: "bg-nsnc",
                [IDS.NSNC2]: "bg-nsnc",
                [IDS.DE_ACUERDO]: "bg-c4",
                [IDS.TOTALMENTE_ACUERDO]: "bg-c5",
              },
            },
            { component: "ColumnChartSimple", question: 15 },
          ],
        },
        {
          id: "riesgo",
          title: this.$t("sections.riesgo.title"),
          desc: this.$t("sections.riesgo.desc"),
          intro: this.$t("sections.riesgo.intro"),
          components: [
            {
              component: "StackedSegmentsFollowUp",
              question: 6,
              defaultOrder: IDS.MUY_ALTO,
              order: {
                // [IDS.CANCER_ACTUALIDAD]: 0,
                [IDS.MUY_ALTO]: 5,
                [IDS.ALTO]: 4,
                [IDS.NSNC]: 3,
                [IDS.BAJO]: 2,
                [IDS.MUY_BAJO]: 1,
              },
              colors: {
                // [IDS.CANCER_ACTUALIDAD]: "bg-gray-800",
                [IDS.MUY_ALTO]: "bg-c1",
                [IDS.ALTO]: "bg-c2",
                [IDS.NSNC]: "bg-nsnc",
                [IDS.BAJO]: "bg-c4",
                [IDS.MUY_BAJO]: "bg-c5",
              },
            },
            {
              component: "HeatMapSimple",
              question: 7,
              order: {
                "1": 1,
                "2": 2,
                "3": 3,
                "4": 4,
                "5": 5,
                "6": 6,
                "7": 7,
                "8": 8,
                "9": 9,
                "10": 10,
              },
              defaultOrder: 9, // the INDEX of the column to order by
              orderDir: 1,
              colors: [colors["1light"], colors.c1],
            },
            { component: "DonutBarChart", question: 9 },
          ],
        },

        {
          id: "salud",
          title: this.$t("sections.salud.title"),
          desc: this.$t("sections.salud.desc"),
          intro: this.$t("sections.salud.intro"),
          components: [
            {
              component: "StackedSegments",
              question: 1,
              defaultOrder: IDS.MUY_BUENO,
              order: {
                [IDS.MUY_MALO]: 0,
                [IDS.MALO]: 1,
                [IDS.REGULAR]: 2,
                [IDS.NSNC]: 3,
                [IDS.BUENO]: 4,
                [IDS.MUY_BUENO]: 5,
              },
              colors: {
                [IDS.MUY_MALO]: "bg-c1",
                [IDS.MALO]: "bg-c2",
                [IDS.REGULAR]: "bg-c3",
                [IDS.NSNC]: "bg-nsnc",
                [IDS.BUENO]: "bg-c4",
                [IDS.MUY_BUENO]: "bg-c5",
              },
            },
            {
              component: "StackedSegments",
              question: 2,
              defaultOrder: IDS.MUY_SALUDABLE,
              order: {
                [IDS.NADA_SALUDABLE]: 0,
                [IDS.POCO_SALUDABLE]: 1,
                [IDS.NSNC]: 2,
                [IDS.BASTANTE_SALUDABLE]: 3,
                [IDS.MUY_SALUDABLE]: 4,
              },
              colors: {
                [IDS.NADA_SALUDABLE]: "bg-c1",
                [IDS.POCO_SALUDABLE]: "bg-c2",
                [IDS.NSNC]: "bg-nsnc",
                [IDS.BASTANTE_SALUDABLE]: "bg-c4",
                [IDS.MUY_SALUDABLE]: "bg-c5",
              },
            },
          ],
        },
        {
          id: "sintomas",
          title: this.$t("sections.sintomas.title"),
          desc: this.$t("sections.sintomas.desc"),
          intro: this.$t("sections.sintomas.intro"),
          components: [
            { component: "DonutBarChart", question: 8 },
            {
              component: "HeatMapSimple",
              question: 12,
              order: {
                [IDS.TAN_PRONTO]: 0,
                [IDS.MENOS_DE_UNA_SEMANA]: 1,
                [IDS.DE_1_A_2_SEMANAS]: 2,
                [IDS.DE_2_A_3_SEMANAS]: 3,
                [IDS.DE_3_A_4_SEMANAS]: 4,
                [IDS.MAS_DE_UN_MES]: 5,
                [IDS.NO_CONTACTARIA]: 6,
              },
              colors: [colors["1light"], colors.c1],
            },
            {
              component: "StackedSimpleFollowUp",
              question: 13,
              defaultOrder: IDS.A_MENUDO,
              order: {
                [IDS.A_MENUDO]: 3,
                [IDS.A_VECES]: 2,
                // [IDS.NSNC]: 1,
                [IDS.NO]: 0,
              },
              colors: {
                [IDS.A_MENUDO]: "bg-c1",
                [IDS.A_VECES]: "bg-c2",
                // [IDS.NSNC]: "bg-nsnc",
                [IDS.NO]: "bg-c4",
              },
            },
          ],
        },
      ],
      showMenu: false,
      scrollOffset: 176,
      showModal: false,
    };
  },
  methods: {
    // https://www.npmjs.com/package/vue-scrollactive#events
    onItemChanged(event, item /*lastActiveItem*/) {
      if (item) {
        history.replaceState(null, null, item.href);
      }
    },
  },
  mounted() {
    // document.addEventListener("scroll", (e) => {
    //   console.log(e);
    // });

    // let prevScrollpos = window.pageYOffset;
    window.onscroll = () => {
      let currentScrollPos = window.pageYOffset;
      if (currentScrollPos > 400) {
        // document.getElementById("navbar").style.top = "0";
        this.showMenu = true;
      } else {
        // document.getElementById("navbar").style.top = "-50px";
        this.showMenu = false;
      }
      // prevScrollpos = currentScrollPos;
    };
  },
};
</script>
<style>
@layer components {
  .scroll-active {
    @apply text-primary ring-2 ring-offset-gray-100 ring-primary;
    /* @apply text-black bg-white !important; */
  }
}
</style>
